import { FormikInputView } from './formik-input-view';

export const FormikPasswordView = ({
  name,
  label,
  autoComplete = 'new-password',
  type = 'password',
  className,
  formik,
  ...other
}) => (
  <FormikInputView
    label={label}
    autoComplete={autoComplete}
    className={className}
    name={name}
    type={type}
    formik={formik}
    {...other}
  />
);
